export default __webpack_public_path__ + "static/media/mintLive.4e51d184.png";